<template>
  <div>
    <Widget>
      <form-wizard shape="tab" color="#3498db" title="" subtitle="" @on-change="updateProgress"
        @on-loading="updateProgress(1, 1)">
        <b-progress class="progress-xs" variant="info" :value="progress" :max="2" />
        <b-button slot="prev" variant="primary" class="text-white">
          <i class="fa fa-caret-left" /> Sebelumnya
        </b-button>
        <b-button slot="next" variant="primary" id="selanjutnya" hidden class="text-white">
          Selanjutnya <i class="fa fa-caret-right" />
        </b-button>
        <b-button slot="finish" variant="success" class="text-white" @click="finish()">
          Selesai <i class="fa fa-check" />
        </b-button>
        <tab-content title="Formulir Pendaftaran" style="background-color: white">
          <legend>Detail Pemohon</legend>
          <div class="row">
            <div class="col-md-6">
              <label>NIK Pemohon</label>
              <b-form-input disabled v-model="form.nik_pemohon" v-validate="'required'" name="nik"
                :class="{ input: true, 'is-invalid': errors.has('nik') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('nik')">
                {{ errors.first("nik") }}
              </span>
            </div>
            <div class="col-md-6">
              <label>Nama Pemohon</label>
              <b-form-input disabled v-model="form.nama_pemohon" v-validate="'required'" name="nama"
                :class="{ input: true, 'is-invalid': errors.has('nama') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('nama')">
                {{ errors.first("nama") }}
              </span>
            </div>
            <div class="col-md-6 mt-3">
              <label>Jabatan Pemohon</label>
              <b-form-input disabled v-model="form.jabatan_pemohon" v-validate="'required'" name="jabatan"
                :class="{ input: true, 'is-invalid': errors.has('jabatan') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('jabatan')">
                {{ errors.first("jabatan") }}
              </span>
            </div>

            </div>

            <legend class="mt-4">Detail Instansi/Perusahaan/Perorangan</legend>
            <div class="row">

            <div class="col-md-6">
              <label>Nama</label>
              <b-form-input disabled v-model="form.instansi_pemohon" v-validate="'required'" name="instansi"
                :class="{ input: true, 'is-invalid': errors.has('instansi') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('instansi')">
                {{ errors.first("instansi") }}
              </span>
            </div>

            <div class="col-md-6">
              <label>NPWP</label>
              <b-form-input disabled v-model="form.npwp_pemohon" v-mask="'##.###.###.#-###.####'" v-validate="'required'"
                name="npwp" :class="{ input: true, 'is-invalid': errors.has('npwp') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('npwp')">
                {{ errors.first("npwp") }}
              </span>
            </div>

            <div class="col-md-6 mt-3">
              <label>Email</label>
              <b-form-input disabled v-model="form.email_pemohon" v-validate="'required'" name="email"
                :class="{ input: true, 'is-invalid': errors.has('email') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('email')">
                {{ errors.first("email") }}
              </span>
            </div>
            
            <div class="col-md-6 mt-3">
              <label>Alamat</label>
              <b-form-textarea disabled v-model="form.alamat_pemohon" v-validate="'required'" name="alamat"
                :class="{ input: true, 'is-invalid': errors.has('alamat') }"></b-form-textarea>
              <span class="text-danger" v-if="errors.has('alamat')">
                {{ errors.first("alamat") }}
              </span>
            </div>

            <div class="col-md-6 mt-3">
              <label>No. Handphone</label>
              <b-form-input disabled v-model="form.no_hp_pemohon" v-validate="'required'" name="no_hp"
                :class="{ input: true, 'is-invalid': errors.has('no_hp') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('no_hp')">
                {{ errors.first("no_hp") }}
              </span>
            </div>

            <div class="col-md-6 mt-3">
              <label>No. Telepon </label>
              <b-form-input disabled v-model="form.no_telepon_pemohon" v-validate="'required'" name="no_telp"
                :class="{ input: true, 'is-invalid': errors.has('no_telp') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('no_telp')">
                {{ errors.first("no_telp") }}
              </span>
            </div>

            
            </div>

            <legend class="mt-4">Detail Permohonan</legend>
            <div class="row">
            <div class="col-md-6">
              <label>Provinsi</label>
              <v-select id="default-select" disabled v-model="form.provinsi" :reduce="(data) => data.nama_provinsi"
                label="nama_provinsi" :options="dataProvinsi" @input="getKabupaten()" name="provinsi"
                v-validate="'required'" :class="{ input: true, 'is-invalid': errors.has('provinsi') }" />
              <span class="text-danger" v-if="errors.has('provinsi')">
                {{ errors.first("provinsi") }}
              </span>
            </div>
            <div class="col-md-6">
              <label>Kabupaten</label>
              <v-select id="default-select" disabled v-model="form.kabupaten" :reduce="(data) => data.nama_kabupaten"
                label="nama_kabupaten" :options="dataKabupaten" @input="getKecamatan()" name="kabupaten"
                v-validate="'required'" :class="{ input: true, 'is-invalid': errors.has('kabupaten') }" />
              <span class="text-danger" v-if="errors.has('kabupaten')">
                {{ errors.first("kabupaten") }}
              </span>
            </div>
            <div class="col-md-6 mt-3">
              <label>Kecamatan</label>
              <v-select id="default-select" disabled v-model="form.kecamatan" :reduce="(data) => data.nama_kecamatan"
                label="nama_kecamatan" :options="dataKecamatan" name="kecamatan" v-validate="'required'"
                :class="{ input: true, 'is-invalid': errors.has('kecamatan') }" />
              <span class="text-danger" v-if="errors.has('kecamatan')">
                {{ errors.first("kecamatan") }}
              </span>
            </div>
            <div class="col-md-6 mt-3">
              <label>Jenis Kegiatan</label>
              <b-form-input disabled v-model="form.jenis_kegiatan" name="kegiatan" v-validate="'required'"
                :class="{ input: true, 'is-invalid': errors.has('kegiatan') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('kegiatan')">
                {{ errors.first("kegiatan") }}
              </span>
            </div>
            <!-- <div class="col-md-6 mt-3">
              <label>Skala Usaha</label>
              <v-select
                id="default-select"
                disabled v-model="form.skala_usaha"
                :options="dataSkalaUsaha"
                name="skala"
                v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('skala') }"
              />
              <span class="text-danger" v-if="errors.has('skala')">
                {{ errors.first("skala") }}
              </span>
            </div> -->
            <div class="col-md-6 mt-3">
              <label>Reklamasi</label>
              <v-select id="default-select" disabled v-model="form.reklamasi" :reduce="(data) => data.value" label="text"
                :options="dataReklamasi" name="reklamasi" v-validate="'required'"
                :class="{ input: true, 'is-invalid': errors.has('reklamasi') }" />
              <span class="text-danger" v-if="errors.has('reklamasi')">
                {{ errors.first("reklamasi") }}
              </span>
            </div>
            <div class="col-md-6 mt-3">
              <label>Nama Perairan</label>
              <b-form-input disabled v-model="form.nama_perairan" name="perairan" v-validate="'required'"
                :class="{ input: true, 'is-invalid': errors.has('perairan') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('perairan')">
                {{ errors.first("perairan") }}
              </span>
            </div>
            <div class="col-md-6 mt-3">
              <label>PSN</label>
              <v-select id="default-select" disabled v-model="form.psn" :options="dataPSN" name="psn" v-validate="'required'"
                :class="{ input: true, 'is-invalid': errors.has('psn') }" />
              <span class="text-danger" v-if="errors.has('psn')">
                {{ errors.first("psn") }}
              </span>
            </div>
            <!-- <b-col md="6" class="mt-3">
              <label>Jenis Permohonan</label>
              <v-select id="default-select" disabled v-model="form.jenis_pnbp" :options="[
                'Area',
                'Kabel Bawah Laut',
                'Pipa Air Bersih / Air Baku',
                'Pipa Selain Air Bersih / Air Baku',
              ]" name="Jenis Permohonan" v-validate="'required'"
                :class="{ 'is-invalid': errors.has('form-1.Jenis Permohonan') }" @input="resetPNBP" />
              <span class="text-danger" v-if="errors.has('Jenis Permohonan')">
                {{ errors.first("Jenis Permohonan") }}
              </span>
            </b-col>
            <b-col md="2" class="mt-3" v-if="form.jenis_pnbp == 'Area'">
              <label>Luas (ha) *</label>
              <b-form-input min="0" step=".01" type="number" name="Luas" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Luas'),
              }" disabled v-model="form.luas" />
              <span class="text-danger" v-if="errors.has('form-1.Luas')">
                {{ errors.first("form-1.Luas") }}
              </span>
            </b-col>


            <b-col md="2" class="mt-3" v-if="
              form.jenis_pnbp == 'Kabel Bawah Laut' ||
              form.jenis_pnbp == 'Pipa Air Bersih / Air Baku' ||
              form.jenis_pnbp == 'Pipa Selain Air Bersih / Air Baku'
            ">
              <label>Panjang (Km)</label>

              <b-form-input min="0" step=".01" type="number" name="Panjang" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Panjang'),
              }" disabled v-model="form.panjang_nonkonservasi" />
            </b-col>
            <div class="col-md-2 mt-3">
              <label>Kedalaman (mdpl)</label>
              <b-form-input disabled v-model="form.kedalaman" type="number" name="kedalaman" v-validate="'required'"
                :class="{ input: true, 'is-danger': errors.has('kedalaman') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('kedalaman')">
                {{ errors.first("kedalaman") }}
              </span>
            </div> -->

            <div class="col-md-6 mt-3">
                  <b-form-group label-for="Form" label ="Jenis Permohonan">
                    <v-select id="default-select" disabled v-model="form.jenis_pnbp" :options="[
                      'Area',
                      'Kabel Bawah Laut',
                      'Pipa Air Bersih / Air Baku',
                      'Pipa Selain Air Bersih / Air Baku',
                    ]" v-validate="'required'" name="Jenis Permohonan"
                      :class="{ 'is-invalid': errors.has('Jenis Permohonan') }" @input="handleJenisPNBPChange"
                      :multiple="true" :close-on-select="false" />
                      
                    <span class="text-danger" v-if="errors.has('Jenis Permohonan')">
                      {{ errors.first("Jenis Permohonan") }}
                    </span>
                  </b-form-group>
            </div>
                <div class="col-md-6 mt-3" v-if="form.jenis_pnbp != null && form.jenis_pnbp.includes('Area')">
                  <b-form-group label-for="Form" label ="Luas (ha)">
                    <b-form-input min="0" step=".01" type="number" name="Luas" v-validate="'required'" :class="{'is-invalid': errors.has('Luas'),
                    }" disabled v-model="form.luas" />
                    <span class="text-danger" v-if="errors.has('Luas')">
                      {{ errors.first("Luas") }}
                    </span>
                  </b-form-group>
                </div>

                <div class="col-md-6 mt-3" v-if="form.jenis_pnbp != null && (
                  form.jenis_pnbp.includes('Kabel Bawah Laut') ||
                  form.jenis_pnbp.includes('Pipa Air Bersih / Air Baku') ||
                  form.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku'))
                ">
                  <b-form-group label-for="Form" label ="Panjang (di dalam Kws. Konservasi)(km)">
                    <b-form-input min="0" step=".01" type="number" name="Panjang (di dalam Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has(
                        'Panjang (di dalam Kws. Konservasi)(km)'
                      ),
                    }" disabled v-model="form.panjang_konservasi" />
                    <span class="text-danger" v-if="errors.has('Panjang (di dalam Kws. Konservasi)(km)')">
                      {{ errors.first("Panjang (di dalam Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </div>
                <div class="col-md-6 mt-3" v-if="form.jenis_pnbp != null &&
                  (form.jenis_pnbp.includes('Kabel Bawah Laut') ||
                  form.jenis_pnbp.includes('Pipa Air Bersih / Air Baku') ||
                  form.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku'))
                ">
                  <b-form-group label-for="Form" label ="Panjang (di luar Kws. Konservasi)(km)">
                    <b-form-input min="0" step=".01" type="number" name="Panjang (di luar Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('Panjang (di luar Kws. Konservasi)(km)'),
                    }" disabled v-model="form.panjang_nonkonservasi" />
                    <span class="text-danger" v-if="errors.has('Panjang (di luar Kws. Konservasi)(km)')">
                      {{ errors.first("Panjang (di luar Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </div>

                <div class="col-md-6 mt-3">
              <b-form-group label-for="Form" label ="Kedalaman (mdpl)">
              <b-form-input disabled v-model="form.kedalaman" type="number" name="kedalaman" v-validate="'required'"
                :class="{ 'form-control': true, 'is-invalid': errors.has('kedalaman') }"></b-form-input>
              <span class="text-danger" v-if="errors.has('kedalaman')">
                {{ errors.first("kedalaman") }}
              </span>
            </b-form-group>
            </div>
          </div>

          <div class="row justify-content-between mt-5">
            <div class="col-4">
              <div class="text-left"></div>
            </div>
            <div class="col-4">
              <div class="text-right">
                <b-button @click="simpanSelanjutnya()" style="float: right" variant="primary">Selanjutnya <i
                    class="fa fa-caret-right" />
                </b-button>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Dokumen" style="background-color: white">
          <b-form>
            <b-row>
              <b-col md="5">
                <p style="font-weight: 900; font-size: 17px">
                  Surat Permohonan Perizinan Non Berusaha
                </p>
              </b-col>
              <b-col md="3">
               
              </b-col>
              <b-col md="4">
                <b-form-group>
                  
                  <b-button variant="success" v-if="
                    form.filename_surat_permohonan_perizinan_nonberusaha ==
                    null
                  " disabled data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                    style="margin-right: 5px"><i class="fa fa-download" /> Download</b-button>
                  <a :href="form.filename_surat_permohonan_perizinan_nonberusaha" v-else type="button"
                    class="btn btn-success" target="_blank" rel="noopener noreferrer"><i class="fa fa-download" />
                    Download</a>
                  <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
                </b-form-group>
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-weight: 900; font-size: 17px">Koordinat</p>
              </b-col>
              <b-col md="3">
                
              </b-col>
              <b-col md="4">
                <b-form-group>
                  

                  <b-button variant="success" v-if="form.file_kordinat == null" disabled data-toggle="tooltip"
                    data-placement="top" title="Tidak ada data" class="text-white" style="margin-right: 5px"><i
                      class="fa fa-download" /> Download</b-button>
                  <a :href="form.file_kordinat" v-else type="button" class="btn btn-success" target="_blank"
                    rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>
                </b-form-group>
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <div class="divider div-transparent"></div>
              <b-col md="5">
                <p style="font-weight: 900; font-size: 17px">
                  Rencana Bangunan dan Instalasi di Laut
                </p>
              </b-col>
              <b-col md="3">
                
              </b-col>
              <b-col md="4">
               <b-button variant="success" v-if="
                  form.file_rencana_bangunan_dan_instalasi_di_laut == null
                " disabled data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                  style="margin-right: 5px"><i class="fa fa-download" /> Download</b-button>
                <a :href="form.file_rencana_bangunan_dan_instalasi_di_laut" v-else type="button" class="btn btn-success"
                  target="_blank" rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>
              </b-col>
              <!-- <b-col md="12" class="divider-col">
                            <hr class="style1 hr-blurry" md="12">
                        </b-col> -->
              <b-col md="12">
                <div class="hr-sect">Rencana Kegiatan</div>
              </b-col>
              <!-- <b-col md="3">
                        
                        </b-col>
                        <b-col md="4">
                        
                        </b-col> -->
              <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->

              <b-col md="8">
                <div>
                  Dokumen dasar berupa kegiatan, tujuan dan manfaat kegiatan
                  usaha
                </div>
              </b-col>
              <!-- <b-col md="3">
                            <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group>
                        </b-col> -->

              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>

              <b-col md="5">
                <div>Kegiatan eksisting yang dimohonkan</div>
              </b-col>
              <b-col md="3"> </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Rencana jadwal pelaksanaan kegiatan utama dan pendukungnya
                </div>
              </b-col>

              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Rencana tapak/site plan kegiatan yang dilengkapi dengan
                  rencana bangunan dan instalasi di laut serta fasilitas
                  penunjangnya
                </div>
              </b-col>

              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Deksriptif luasan (Ha) yang dibutuhkan pada lokasi usaha yang
                  dimohonkan per kegiatan utama dan penunjangnya
                </div>
              </b-col>

              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Peta lokasi/plotting batas-batas area dan/atau jalur disertai
                  titik koordinat lokasi dengan sistem koordinat lintang
                  (latitude) dan bujur (longitude) berskala minimal 1:50.000.
                </div>
              </b-col>

              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>
                  <p style="font-weight: 900; font-size: 17px">
                    Informasi Pemanfaatan Ruang Laut
                  </p>
                </div>
              </b-col>
              <b-col md="3">
                
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <b-button variant="success" v-if="form.file_informasi_prl == null" disabled data-toggle="tooltip"
                    data-placement="top" title="Tidak ada data" class="text-white" style="margin-right: 5px"><i
                      class="fa fa-download" /> Download</b-button>
                  <a :href="form.file_informasi_prl" v-else type="button" class="btn btn-success" target="_blank"
                    rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>
                  <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
                </b-form-group>
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Informasi Pemanfaatan Ruang Laut di sekitar Area Permohonan
                </div>
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12">
              </b-col>
              <b-col md="5">
                <div>
                  <p style="font-weight: 900; font-size: 17px">
                    Data kondisi terkini lokasi dan sekitarnya (ekosistem,
                    hidrografi, dan oseanografi)
                  </p>
                </div>
              </b-col>
              <b-col md="3">
                
              </b-col>
              <b-col md="4">
                <b-button variant="success" v-if="form.file_data_kondisi_terkini == null" disabled data-toggle="tooltip"
                  data-placement="top" title="Tidak ada data" class="text-white" style="margin-right: 5px"><i
                    class="fa fa-download" /> Download</b-button>
                <a :href="form.file_data_kondisi_terkini" v-else type="button" class="btn btn-success" target="_blank"
                  rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>
              </b-col>
              <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
              <b-col md="12">
                <div class="hr-sect">Ekosistem Sekitar</div>
              </b-col>
              <!-- <b-col md="3">
                        </b-col>
                        <b-col md="4">
                        </b-col> -->
              <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
              <b-col md="5">
                <div>Mangrove</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Lamun</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>Terumbu karang</div>
              </b-col>

              <b-col md="12">
                <div class="hr-sect">Hidro-oseanografi</div>
              </b-col>
              <!-- <b-col md="3">
                        
                        </b-col>
                        <b-col md="4">
                        
                        </b-col>
                        <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
              <b-col md="5">
                <div>Arus</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Gelombang</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Pasang Surut</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Bathimetri</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-size: 15px">Profil dasar laut disertai gambar</p>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-size: 15px">
                  Kondisi/karakteristik sosial ekonomi masyarakat
                </p>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-size: 15px">Aksesibilitas lokasi dan sekitar</p>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>


              <template v-if="form.reklamasi == true">
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-weight: 900; font-size: 17px">
                    Persyaratan Reklamasi
                  </p>
                </b-col>
                <b-col md="3">
                  
                </b-col>
                <b-col md="4">
                  <b-form-group>
                   <b-button variant="success" v-if="form.file_persyaratan_reklamasi == null" disabled
                      data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                      style="margin-right: 5px"><i class="fa fa-download" /> Download</b-button>
                    <a :href="form.file_persyaratan_reklamasi" v-else type="button" class="btn btn-success"
                      target="_blank" rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>
                    <!-- <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                        <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                    </div> -->
                  </b-form-group>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Rencana pengambilan sumber material reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                </b-col>

                <b-col md="5">
                  <div>Rencana pemanfaatan lahan reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Gambaran umum pelaksanaan reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Jadwal rencana pelaksanaan reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                </b-col>

              </template>

              <template v-if="tipe == 'Pemerintah'">
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col v-if="tipe == 'Pemerintah'" md="5">
                  <p style="font-weight: 900; font-size: 17px">
                    Persyaratan Lainnya
                  </p>
                </b-col>
                <b-col v-if="tipe == 'Pemerintah'" md="3">
                  
                </b-col>
                <b-col v-if="tipe == 'Pemerintah'" md="4">
                  <b-form-group>
                   <b-button variant="success" v-if="form.file_persyaratan_lain == null" disabled data-toggle="tooltip"
                      data-placement="top" title="Tidak ada data" class="text-white" style="margin-right: 5px"><i
                        class="fa fa-download" /> Download</b-button>
                    <a :href="form.file_persyaratan_lain" v-else type="button" class="btn btn-success" target="_blank"
                      rel="noopener noreferrer" download><i class="fa fa-download" /> Download</a>
                    <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
                  </b-form-group>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col v-if="tipe == 'Pemerintah'" md="8">
                  <div>
                    Surat Permohonan Pengenaan Tarif Rp 0,00 (Nol Rupiah)
                  </div>
                </b-col>


                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col v-if="tipe == 'Pemerintah'" md="8">
                  <div>
                    Bukti Penggunaan APBN/APBD untuk Pemohon dari Instansi Pusat/Daerah
                  </div>
                </b-col>



              </template>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-weight: 900; font-size: 17px">
                  Link Dokumen
                </p>
              </b-col>
              <b-col md="7">
                <b-form-input disabled v-model="form.url_bahan_rapat"
                  placeholder="Silahkan masukkan link dokumen dari Cloud Storage, Seperti Google Drive, Dropbox, dll."></b-form-input>
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
            </b-row>
          </b-form>
        </tab-content>
      </form-wizard>
    </Widget>
  </div>
</template>

<script>
import Vue from "vue";
import Widget from "@/components/Widget/Widget";
import vSelect from "vue-select";
import axios from "axios";
import Swal from "sweetalert2";
import { formatDate } from "../../helper/helpernew"

export default {
  components: {
    Widget,
    vSelect,
    formatDate
  },
  data() {
    return {
      progress: 1,
      id_permohonan: localStorage.getItem("id_permohonan"),
      tipe: localStorage.getItem("tipe_pemohon"),
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      form: {},
      dataProvinsi: [],
      dataKabupaten: [],
      dataKecamatan: [],
      dataSkalaUsaha: ["Besar", "Menengah", "Mikro"],
      dataPSN: ["PSN", "Non PSN"],
      dataReklamasi: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      inputFiles: [],
      dataPerDokumen: [],
      dataUser: [],
      file_1: null,
      file_2: null,
      file_3: null,
      file_4: null,
      file_5: null,
      file_6: null,
      file_7: null,
      optionsBentukUsaha: [
        { value: 'BUMN', text: "BUMN" },
        { value: 'BUMD', text: "BUMD" },
        { value: 'Lainnya', text: "Lainnya" },
      ],
    };
  },
  mounted() {
    this.form.jenis_pnbp = []
    this.getProvinsi();
    this.loadData();
  },
  methods: {
    simpanSelanjutnya() {
      let btn = document.getElementById("selanjutnya");
    btn?.click();
    },
    updateProgress(prevIndex, nextIndex) {
      console.log(prevIndex + ":" + nextIndex);
      if (nextIndex >= 0) {
        if (nextIndex == 1) {
        } else if (nextIndex == 2) {
        }
        Vue.set(this, "progress", nextIndex + 1);
      }
    },

    finish() {
    if (this.form.tipe_pemohon == "Pemerintah") {
            this.$router.push("/app/permohonan/non-berusaha/pemerintah");
          } else {
            this.$router.push("/app/permohonan/non-berusaha/swasta");
          }
    },

    resetPNBP() {
      this.form.luas = null
      this.form.panjang_konservasi = null
      this.form.panjang_nonkonservasi = null
    },

    loadData() {
      const id_permohonan = this.$route.params.id;
      axios
        .get(this.baseapi + "api/permohonan_nonberusaha/" + id_permohonan, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.form = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    getProvinsi() {
      axios
        .get(this.baseapi + "api/provinsi?sort=id,ASC", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataProvinsi = response.data.data;
          this.getKabupaten();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getKabupaten() {
      axios
        .get(
          this.baseapi +
          "api/kabupaten?filter=nama_provinsi,=," +
          this.form.provinsi,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataKabupaten = response.data.data;
          this.getKecamatan();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getKecamatan() {
      axios
        .get(
          this.baseapi +
          "api/kecamatan?filter=nama_kabupaten,=," +
          this.form.kabupaten,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataKecamatan = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    

    format_date(val, format) {
      if (val)
        return formatDate(val, format)
    },

   
    simpanFile(jenis) {
      const id_permohonan = localStorage.getItem("id_permohonan");
      let formData = new FormData();
      if (jenis == "kordinat") {
        formData.append("file_kordinat", this.file_1);
      } else if (jenis == "bangunan") {
        formData.append(
          "file_rencana_bangunan_dan_instalasi_di_laut",
          this.file_2
        );
      } else if (jenis == "prl") {
        formData.append("file_informasi_prl", this.file_3);
      } else if (jenis == "kondisi") {
        formData.append("file_data_kondisi_terkini", this.file_4);
      } else if (jenis == "lain") {
        formData.append("file_persyaratan_lain", this.file_5);
      } else if (jenis == "reklamasi") {
        formData.append("file_persyaratan_reklamasi", this.file_6);
      } else if (jenis == "surat") {
        formData.append(
          "filename_surat_permohonan_perizinan_nonberusaha",
          this.file_7
        );
      }

      this.$loading(true)
      axios
        .post(
          this.baseapi + "api/permohonan_nonberusaha/" + id_permohonan,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$toasted.success("Berhasil Diunggah");
          this.file_1 = null;
          this.file_2 = null;
          this.file_3 = null;
          this.file_4 = null;
          this.file_5 = null;
          this.file_6 = null;
          this.file_7 = null;
          this.loadData();
          return response;
        })
        .catch((error) => {
          this.$toasted.danger("Gagal Diunggah");
          return error;
        }).finally(()=>{
          this.$loading(false)
        });
    },
    onChangeInputFiles(e) {
      const files = [];
      let i = 0;
      for (i; i < e.target.files.length; i += 1) {
        files.push(e.target.files[i]);
      }

      Vue.set(this, "inputFiles", files);
    },
    removeFiles() {
      Vue.set(this, "inputFiles", []);
    },

    handleJenisPNBPChange(selected) {
      this.form.luas = null;
      this.form.panjang_konservasi = null;
      this.form.panjang_nonkonservasi = null;

      console.log(selected.length)
      if (selected.length > 2) {
        selected.pop(); // buang pilihan terakhir
        this.$toasted.error("Maksimal 2 Jenis Permohonan")
      }
      if ((selected.length === 2 && selected.includes('Area') == false)) {
        this.$toasted.error("Salah Satu Jenis Permohonan Wajib Pilih Area")
        return selected.pop();
      }
      this.form.jenis_pnbp = selected;
    },
  },
};
</script>